import React from 'react';
import View from "react-native-web/dist/exports/View";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import Platform from "react-native-web/dist/exports/Platform";
import PropTypes from 'prop-types';
import StackView from '../StackView';
import Typography from '../Typography';
import RenderActivityIndicator from './RenderActivityIndicator';
import { BACKDROP_Z_INDEX, SPACE_WITH_LABEL, SPACE_WITHOUT_LABEL } from './shared';
import { activityIndicatorCommonProps } from './sharedProptypes';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const FullScreenIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    variantProps,
    label,
    labelPosition,
    labelMapping,
    backgroundColor,
    showLabel
  } = _ref;
  return /*#__PURE__*/_jsx(View, {
    style: [staticStyles.fullScreenOverlay, {
      backgroundColor
    }],
    children: /*#__PURE__*/_jsxs(StackView, {
      space: showLabel ? SPACE_WITH_LABEL : SPACE_WITHOUT_LABEL,
      tokens: {
        alignItems: 'center'
      },
      direction: labelMapping[labelPosition],
      children: [/*#__PURE__*/_jsx(RenderActivityIndicator, {
        ...variantProps,
        ref: ref,
        label: label
      }), showLabel && /*#__PURE__*/_jsx(Typography, {
        children: label
      })]
    })
  });
});
FullScreenIndicator.displayName = 'FullScreenIndicator';
const staticStyles = StyleSheet.create({
  fullScreenOverlay: {
    ...Platform.select({
      web: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: BACKDROP_Z_INDEX,
        justifyContent: 'center',
        alignItems: 'center'
      },
      default: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        justifyContent: 'center',
        alignItems: 'center',
        ...(Platform.OS === 'android' ? {
          elevation: 5
        } : {
          zIndex: BACKDROP_Z_INDEX
        })
      }
    })
  }
});
FullScreenIndicator.propTypes = {
  /**
   * Shared props
   * */
  ...activityIndicatorCommonProps,
  /**
   * Background color for overlay
   * */
  backgroundColor: PropTypes.string.isRequired
};
export default FullScreenIndicator;